import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const H1Styles = css `
  ${fonts.sourceSansPro.bold};
  font-size: 30px;
  line-height: 40px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    font-size: 40px;
    line-height: 50px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 60px;
    line-height: 70px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 70px;
    line-height: 80px;
  }

  .theme-apl & {
    @media ${from(Device.DesktopLarge)} {
      font-size: 60px;
      line-height: 70px;
    }
  }
`;
const H2Styles = css `
  ${fonts.sourceSansPro.bold};
  font-size: 25px;
  line-height: 35px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    font-size: 35px;
    line-height: 45px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 55px;
    line-height: 65px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 60px;
    line-height: 70px;
  }

  .theme-apl & {
    @media ${from(Device.DesktopLarge)} {
      font-size: 55px;
      line-height: 65px;
    }
  }
`;
const H3Styles = css `
  ${fonts.sourceSansPro.bold};
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    font-size: 30px;
    line-height: 40px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 45px;
    line-height: 60px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 50px;
    line-height: 60px;
  }
`;
const H4Styles = css `
  ${fonts.sourceSansPro.semiBold};
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    font-size: 25px;
    line-height: 35px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 35px;
    line-height: 45px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 45px;
    line-height: 55px;
  }
`;
const H5Styles = css `
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    font-size: 22px;
    line-height: 32px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 25px;
    line-height: 35px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 30px;
    line-height: 38px;
  }
`;
const H6Styles = css `
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    font-size: 22px;
    line-height: 32px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 25px;
    line-height: 35px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 30px;
    line-height: 38px;
  }
`;
const Heading = styled.h1 `
  ${({ visual }) => {
    switch (visual) {
        case 'h1':
            return H1Styles;
        case 'h2':
            return H2Styles;
        case 'h3':
            return H3Styles;
        case 'h4':
            return H4Styles;
        case 'h5':
            return H5Styles;
        case 'h6':
            return H6Styles;
        default:
            break;
    }
}}
`;
export default {
    H1Styles,
    H2Styles,
    H3Styles,
    H4Styles,
    H5Styles,
    H6Styles,
    Heading,
};
